import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { StoreSummary } from '../../../models/store/StoreSummary';
import { StoreSummaryResponse } from '../../../../interfaces/response/StoreResponses';

/**
 * An adapter converts store HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreSummaryAdapter implements Adapter<StoreSummary> {

  /**
   * Converts store HTTP response to domain object.
   * @param item store HTTP response.
   */
  adapt(item: StoreSummaryResponse): StoreSummary {
    return new StoreSummary(item.slug, item.name);
  }
}
